import { call, put, takeEvery } from "redux-saga/effects";
import {
  reprintCertificateTypeError,
  reprintCertificateTypeSuccess,
} from "./actions";
import { REPRINT_CERTIFICATE_TYPE } from "./actionTypes";
import { reprintCertificateTypeApi } from "../../resources/helper/reprintCertificates";

function* reprintCertificateType({ payload: { ct } }) {
  try {
    const response = yield call(reprintCertificateTypeApi, ct.id, ct.type);
    yield put(reprintCertificateTypeSuccess(response));
  } catch (error) {
    yield put(reprintCertificateTypeError(error));
  }
}

function* reprintCertiSaga() {
  yield takeEvery(REPRINT_CERTIFICATE_TYPE, reprintCertificateType);
}

export default reprintCertiSaga;
